import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../themes';

class Toggle extends React.PureComponent {
  state = {
    checked: this.props.checked,
  };

  handleToggle = () => {
    if (!this.props.disabled) {
      this.setState(prevState => ({
        checked: !prevState.checked,
      }));
    }
  };

  render() {
    const { name, total, placeholder, disabled, onChange, checked, style } = this.props;
    const disabledClass = disabled ? 'disabled' : '';
    const checkedClass = checked ? 'checked' : null;

    return (
      <div className={`toggle clearfix ${disabledClass}`} style={style}>
        <input
          type="checkbox"
          name={name}
          id={disabled ? '' : name}
          onChange={disabled ? null : onChange}
          defaultChecked={checked}
        />
        <label htmlFor={name} onClick={this.handleToggle} className={checkedClass} />
        <span>
          {placeholder}
          {!checked && total > 0 && <small>{total}</small>}
        </span>
        <style jsx>
          {`
            .toggle {
            }
            input {
              position: absolute;
              left: -8888px;
            }
            label {
              float: left;
              border-radius: 15px;
              box-shadow: inset 0 0 0 1px #d5d5d5;
              display: inline-block;
              position: relative;
              height: 30px;
              margin-left: -2px;
              text-indent: -5000px;
              width: 50px;
            }
            label:before,
            label:after {
              content: '';
              position: absolute;
              display: block;
              height: 30px;
              width: 30px;
              top: 0;
              left: 0;
              border-radius: 15px;
              transition: 0.25s ease-in-out;
            }
            label:before {
              background: rgba(19, 191, 17, 0);
            }
            label:after {
              background: #fff;
              box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.2);
            }
            label.checked:before {
              background: #1481f7;
              width: 50px;
            }
            label.checked:after {
              left: 20px;
              box-shadow: inset 0 0 0 1px #1481f7, 0 2px 4px rgba(0, 0, 0, 0.2);
            }
            span {
              float: left;
              line-height: 30px;
              padding-left: 10px;
            }
            small {
              color: ${colors.gray};
              margin-left: 8px;
            }
            .disabled {
              opacity: 0.5;
            }
            :global(.rtl) label {
              float: right;
            }
            :global(.rtl) span {
              float: right;
              padding-left: 0;
              padding-right: 10px;
            }
            :global(.rtl) small {
              margin-left: 0;
              margin-right: 8px;
            }
            :global(.rtl) label:before,
            :global(.rtl) label:after {
              left: auto;
              right: 0;
            }
            :global(.rtl) label.checked:after {
              right: 20px;
              left: 0;
            }
            :global(.rtl) input {
              left: auto;
              right: -8888px;
            }
          `}
        </style>
      </div>
    );
  }
}

Toggle.defaultProps = {
  checked: false,
  placeholder: null,
  total: null,
  disabled: false,
  style: null,
};

Toggle.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  total: PropTypes.number,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default Toggle;



// WEBPACK FOOTER //
// ./app/common/forms/Toggle.js